<template>
<div class="chapter">
<div class="inner_page">
<div class="chaptitle"><span><a id="pagexi"></a><b>CONTENTS</b></span></div>
<div class="toc"><span><span href="#/preface#rpr" id="pr" title="Link target outside of Sample">Preface</span></span></div>
<div class="toc"><span><a href="#/introduction#rin" id="in">Introduction</a></span></div>
<div class="toc"><span>Chapter</span></div>
<div class="toc1"><span><a href="#/ch01#rch1" id="ch1">1.  Recruiting the Volunteers, 1861</a></span></div>
<div class="toc1"><span><span href="#/ch02#rch2" id="ch2" title="Link target outside of Sample">2.  The Organization of the Cavalry, 1862</span></span></div>
<div class="toc1"><span><span href="#/ch03#rch3" id="ch3" title="Link target outside of Sample">3.  Food and Clothing</span></span></div>
<div class="toc1"><span><span href="#/ch04#rch4" id="ch4" title="Link target outside of Sample">4.  Arms and Mounts</span></span></div>
<div class="toc1"><span><span href="#/ch05#rch5" id="ch5" title="Link target outside of Sample">5.  Campaigning: Cane Hill and Prairie Grove</span></span></div>
<div class="toc1"><span><span href="#/ch06#rch6" id="ch6" title="Link target outside of Sample">6.  Raiding Federal Missouri</span></span></div>
<div class="toc1"><span><span href="#/ch07#rch7" id="ch7" title="Link target outside of Sample">7.  Closing Scenes</span></span></div>
<div class="toc"><span><span href="#/part1#rp1" id="p1" title="Link target outside of Sample">Appendices</span></span></div>
<div class="toc2"><span><span href="#/app1#rapp1" id="app1" title="Link target outside of Sample">Appendix A.  List of Confederate Cavalry Regiments and Battalions from the Trans-Mississippi</span></span></div>
<div class="toc2"><span><span href="#/app2#rapp2" id="app2" title="Link target outside of Sample">Appendix B.  Total Strength of Cavalry Units Raised in the Trans-Mississippi</span></span></div>
<div class="toc2"><span><span href="#/app3#rapp3" id="app3" title="Link target outside of Sample">Appendix C.  Organization of Price’s Cavalry Corps</span></span></div>
<div class="toc"><span><span href="#/bib#rbib" id="bib" title="Link target outside of Sample">Bibliography</span></span></div>
<div class="toc"><span><span href="#/index#rind" id="ind" title="Link target outside of Sample">Index</span></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2dce5c17